import { useTranslation } from '@mc/i18n'
import Image from 'components/LegacyImage'
import { STATIC_IMAGE_BASE } from 'libs/constants'

const DEFAULT_WIDTH = 137
const DEFAULT_HEIGHT = 12
const ASPECT_RATIO = DEFAULT_WIDTH / DEFAULT_HEIGHT

interface SeriesLogoProps {
  width: number
  containerClassName?: string
}

export const SeriesLogo = ({
  width = DEFAULT_WIDTH,
  containerClassName = 'mc-my-4',
}: SeriesLogoProps) => {
  const { t } = useTranslation('@mc/next')
  return (
    <div className={containerClassName}>
      <Image
        alt={t('series.details.seriesLogo')}
        src={`${STATIC_IMAGE_BASE}/series-logo.svg`}
        width={width}
        height={width / ASPECT_RATIO}
      />
    </div>
  )
}
